import { useIntl } from 'react-intl';

export const LocaleTitle = ({ lang, id }: { lang: string; id: string }) => {
  const { formatMessage } = useIntl();
  if (!id) return 'missing  ID';
  return formatMessage({ id: id }) + formatMessage({ id: ` (${lang.toUpperCase()})` });
};
